import { render, staticRenderFns } from "./index.vue?vue&type=template&id=152512a6"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\User\\Documents\\legalmerge-prod\\legal-merge\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('152512a6')) {
      api.createRecord('152512a6', component.options)
    } else {
      api.reload('152512a6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=152512a6", function () {
      api.rerender('152512a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ContactedLeadDialog/index.vue"
export default component.exports